var $6e57a09a8cc86920$exports = {};
const $6e57a09a8cc86920$var$API_BASE = "/api";
const $6e57a09a8cc86920$var$authSection = document.getElementById("auth-section");
const $6e57a09a8cc86920$var$wordsSection = document.getElementById("words-section");
const $6e57a09a8cc86920$var$loginForm = document.getElementById("login-form");
const $6e57a09a8cc86920$var$loginMessage = document.getElementById("login-message");
const $6e57a09a8cc86920$var$addWordForm = document.getElementById("add-word-form");
const $6e57a09a8cc86920$var$wordsList = document.getElementById("watched-words-list");
const $6e57a09a8cc86920$var$logoutBtn = document.getElementById("logout-btn");
const $6e57a09a8cc86920$var$llmSummaryToggle = document.getElementById("llm-summary-toggle");
const $6e57a09a8cc86920$var$weeklyDigestToggle = document.getElementById("weekly-digest-toggle");
const $6e57a09a8cc86920$var$savedSearchesList = document.getElementById("saved-searches-list");
const $6e57a09a8cc86920$var$committeeSubsList = document.getElementById("committee-subs-list");
const $6e57a09a8cc86920$var$kommuneSelect = document.getElementById("kommune-select");
const $6e57a09a8cc86920$var$gremienPanel = document.getElementById("gremien-panel");
const $6e57a09a8cc86920$var$gremienList = document.getElementById("gremien-list");
const $6e57a09a8cc86920$var$gremienFilter = document.getElementById("gremien-filter");
const $6e57a09a8cc86920$var$kommuneAllToggle = document.getElementById("kommune-all");
const $6e57a09a8cc86920$var$kommuneAllName = document.getElementById("kommune-all-name");
const $6e57a09a8cc86920$var$inactiveToggle = document.getElementById("gremien-inactive-toggle");
const $6e57a09a8cc86920$var$committeeStatus = document.getElementById("committee-status");
const $6e57a09a8cc86920$var$topicList = document.getElementById("topic-list");
const $6e57a09a8cc86920$var$topicStatus = document.getElementById("topic-status");
const $6e57a09a8cc86920$var$loginLayout = document.getElementById("konto-login-layout");
const $6e57a09a8cc86920$var$loginSubmit = document.getElementById("login-submit");
const $6e57a09a8cc86920$var$accountLine = document.getElementById("konto-account");
const $6e57a09a8cc86920$var$lede = document.getElementById("konto-lede");
const $6e57a09a8cc86920$var$settingsStatus = document.getElementById("settings-status");
const $6e57a09a8cc86920$var$LEDE_LOGGED_OUT = $6e57a09a8cc86920$var$lede ? $6e57a09a8cc86920$var$lede.textContent : "";
// Check for Magic Link token in URL
const $6e57a09a8cc86920$var$urlParams = new URLSearchParams(window.location.search);
const $6e57a09a8cc86920$var$tokenFromUrl = $6e57a09a8cc86920$var$urlParams.get("token");
if ($6e57a09a8cc86920$var$tokenFromUrl) fetch(`${$6e57a09a8cc86920$var$API_BASE}/auth/session`, {
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify({
        token: $6e57a09a8cc86920$var$tokenFromUrl
    })
}).finally(()=>{
    window.history.replaceState({}, document.title, "/konto");
    $6e57a09a8cc86920$var$updateUI();
});
async function $6e57a09a8cc86920$var$apiRequest(endpoint, method = "GET", body = null) {
    const headers = {
        "Content-Type": "application/json"
    };
    const response = await fetch(`${$6e57a09a8cc86920$var$API_BASE}${endpoint}`, {
        method: method,
        headers: headers,
        credentials: "same-origin",
        body: body ? JSON.stringify(body) : null
    });
    if (response.status === 401) {
        $6e57a09a8cc86920$var$updateUI();
        return null;
    }
    // Manche Endpunkte (z. B. /settings) antworten nur mit Status, ohne JSON.
    const type = response.headers.get("content-type") || "";
    if (!type.includes("application/json")) return response.ok ? {} : null;
    return response.json();
}
// --- Themen ---
const $6e57a09a8cc86920$var$topics = {
    names: [],
    subs: [],
    kommunen: [],
    openIndex: null
};
let $6e57a09a8cc86920$var$topicStatusTimer = null;
function $6e57a09a8cc86920$var$showTopicStatus(text, isError = false) {
    if (!$6e57a09a8cc86920$var$topicStatus) return;
    $6e57a09a8cc86920$var$topicStatus.textContent = text;
    $6e57a09a8cc86920$var$topicStatus.classList.toggle("is-error", isError);
    clearTimeout($6e57a09a8cc86920$var$topicStatusTimer);
    if (!isError) $6e57a09a8cc86920$var$topicStatusTimer = setTimeout(()=>{
        $6e57a09a8cc86920$var$topicStatus.textContent = "";
    }, 2500);
}
function $6e57a09a8cc86920$var$topicSub(name) {
    return $6e57a09a8cc86920$var$topics.subs.find((s)=>s.themengruppe === name) || {
        themengruppe: name,
        sessions: false,
        documents: false,
        kommunen: []
    };
}
async function $6e57a09a8cc86920$var$saveTopic(next, focusId) {
    var _document_getElementById;
    const result = await $6e57a09a8cc86920$var$apiRequest("/topic-subscriptions", "PUT", next);
    if (!result) $6e57a09a8cc86920$var$showTopicStatus("Speichern hat nicht geklappt.", true);
    else {
        $6e57a09a8cc86920$var$topics.subs = result;
        $6e57a09a8cc86920$var$showTopicStatus("Gespeichert.");
    }
    $6e57a09a8cc86920$var$renderTopics();
    if (focusId) (_document_getElementById = document.getElementById(focusId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
}
function $6e57a09a8cc86920$var$describeKommunen(list) {
    if (!list.length) return "In allen Kommunen";
    if (list.length <= 2) return `Nur in ${list.join(" und ")}`;
    return `Nur in ${list.length} Kommunen`;
}
function $6e57a09a8cc86920$var$topicCheckbox(id, text, checked, onChange) {
    const label = document.createElement("label");
    label.className = "themen-toggle";
    const cb = document.createElement("input");
    cb.type = "checkbox";
    cb.id = id;
    cb.checked = checked;
    cb.addEventListener("change", ()=>onChange(cb.checked));
    const span = document.createElement("span");
    span.textContent = text;
    label.append(cb, span);
    return label;
}
function $6e57a09a8cc86920$var$renderTopicKommunen(sub, index) {
    const details = document.createElement("details");
    details.className = "themen-kommunen";
    // Offen lassen, solange hier gerade gearbeitet wird.
    if ($6e57a09a8cc86920$var$topics.openIndex === index) details.open = true;
    details.addEventListener("toggle", ()=>{
        if (details.open) $6e57a09a8cc86920$var$topics.openIndex = index;
        else if ($6e57a09a8cc86920$var$topics.openIndex === index) $6e57a09a8cc86920$var$topics.openIndex = null;
    });
    const summary = document.createElement("summary");
    summary.textContent = $6e57a09a8cc86920$var$describeKommunen(sub.kommunen);
    details.appendChild(summary);
    const hint = document.createElement("p");
    hint.className = "themen-kommunen-hint";
    hint.textContent = "Keine Auswahl hei\xdft: alle Kommunen.";
    const grid = document.createElement("div");
    grid.className = "themen-kommunen-grid";
    $6e57a09a8cc86920$var$topics.kommunen.forEach((kommune, k)=>{
        grid.appendChild($6e57a09a8cc86920$var$topicCheckbox(`topic-${index}-k${k}`, kommune, sub.kommunen.includes(kommune), (checked)=>{
            const kommunen = checked ? [
                ...sub.kommunen,
                kommune
            ] : sub.kommunen.filter((x)=>x !== kommune);
            $6e57a09a8cc86920$var$saveTopic({
                ...sub,
                kommunen: kommunen
            }, `topic-${index}-k${k}`);
        }));
    });
    details.append(hint, grid);
    return details;
}
function $6e57a09a8cc86920$var$renderTopics() {
    if (!$6e57a09a8cc86920$var$topicList) return;
    $6e57a09a8cc86920$var$topicList.replaceChildren(...$6e57a09a8cc86920$var$topics.names.map((name, index)=>{
        const sub = $6e57a09a8cc86920$var$topicSub(name);
        const active = sub.sessions || sub.documents;
        const li = document.createElement("li");
        li.className = active ? "themen-item is-active" : "themen-item";
        const title = document.createElement("span");
        title.className = "themen-name";
        title.textContent = name;
        const toggles = document.createElement("div");
        toggles.className = "themen-toggles";
        toggles.setAttribute("role", "group");
        toggles.setAttribute("aria-label", name);
        toggles.append($6e57a09a8cc86920$var$topicCheckbox(`topic-${index}-s`, "Neue Sitzungen", sub.sessions, (checked)=>$6e57a09a8cc86920$var$saveTopic({
                ...sub,
                sessions: checked
            }, `topic-${index}-s`)), $6e57a09a8cc86920$var$topicCheckbox(`topic-${index}-d`, "Neue Dokumente", sub.documents, (checked)=>$6e57a09a8cc86920$var$saveTopic({
                ...sub,
                documents: checked
            }, `topic-${index}-d`)));
        li.append(title, toggles);
        if (active) li.appendChild($6e57a09a8cc86920$var$renderTopicKommunen(sub, index));
        return li;
    }));
}
async function $6e57a09a8cc86920$var$loadTopicKommunen() {
    try {
        const res = await fetch("/api/calendar/municipalities");
        if (res.ok) $6e57a09a8cc86920$var$topics.kommunen = await res.json();
    } catch  {
        $6e57a09a8cc86920$var$topics.kommunen = [];
    }
    $6e57a09a8cc86920$var$renderTopics();
}
// --- Gremien ---
// Gremien ohne Sitzung in diesem Zeitraum gelten als ruhend und sind eingeklappt.
const $6e57a09a8cc86920$var$INACTIVE_AFTER_MS = 63072000000;
// Erst ab dieser Zahl lohnt das Filterfeld über der Liste.
const $6e57a09a8cc86920$var$FILTER_FROM = 12;
// Gruppen nach Art des Gremiums, in Anzeigereihenfolge. Die Themengruppen taugen
// dafür nicht: „Rat“ oder „Schulausschuss“ treffen keines ihrer Stichwörter,
// viele Fachausschüsse dagegen drei auf einmal. Zugeordnet wird über das erste
// passende Muster in MATCH_ORDER, der Rest sind Fachausschüsse.
const $6e57a09a8cc86920$var$GROUPS = {
    rat: "Rat und Verwaltungsausschuss",
    fach: "Fachaussch\xfcsse und Beir\xe4te",
    ortsrat: "Ortsr\xe4te",
    einwohner: "Einwohnerversammlungen",
    weitere: "Weitere Termine"
};
const $6e57a09a8cc86920$var$MATCH_ORDER = [
    [
        "rat",
        /^(?:rat|stadtrat|gemeinderat|samtgemeinderat|kreistag|kreisausschuss|verwaltungsausschuss|samtgemeindeausschuss|hauptausschuss)\b/i
    ],
    [
        "ortsrat",
        /\bortsr(?:at|äte)\b/i
    ],
    [
        "einwohner",
        /^einwohn\w*versammlung/i
    ],
    [
        "weitere",
        /(?:wahl|versammlung|gespräch|konferenz)\b/i
    ]
];
const $6e57a09a8cc86920$var$committees = {
    overview: null,
    subs: [],
    kommuneSubs: [],
    kommune: "",
    query: "",
    showInactive: false
};
async function $6e57a09a8cc86920$var$loadCommitteeOverview() {
    try {
        const res = await fetch("/api/calendar/committee-overview");
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        $6e57a09a8cc86920$var$committees.overview = await res.json();
    } catch  {
        $6e57a09a8cc86920$var$committees.overview = null;
        $6e57a09a8cc86920$var$showCommitteeStatus("Die Gremien konnten nicht geladen werden.", true);
        return;
    }
    // Erste Option „Kommune wählen …“ behalten, Rest bei erneutem Laden ersetzen.
    while($6e57a09a8cc86920$var$kommuneSelect.options.length > 1)$6e57a09a8cc86920$var$kommuneSelect.remove(1);
    $6e57a09a8cc86920$var$committees.overview.kommunen.forEach(({ kommune: kommune, gremien: gremien })=>{
        const opt = document.createElement("option");
        opt.value = kommune;
        opt.textContent = `${kommune} (${gremien.length} Gremien)`;
        $6e57a09a8cc86920$var$kommuneSelect.appendChild(opt);
    });
    // Ohne Auswahl die Kommune öffnen, in der schon Abos bestehen.
    if (!$6e57a09a8cc86920$var$committees.kommune) {
        const known = new Set($6e57a09a8cc86920$var$committees.overview.kommunen.map((k)=>k.kommune));
        $6e57a09a8cc86920$var$committees.kommune = [
            ...$6e57a09a8cc86920$var$committees.kommuneSubs,
            ...$6e57a09a8cc86920$var$committees.subs
        ].map((s)=>s.kommune).find((k)=>known.has(k)) || "";
    }
    $6e57a09a8cc86920$var$kommuneSelect.value = $6e57a09a8cc86920$var$committees.kommune;
    $6e57a09a8cc86920$var$renderGremienPicker();
}
let $6e57a09a8cc86920$var$committeeStatusTimer = null;
function $6e57a09a8cc86920$var$showCommitteeStatus(text, isError = false) {
    if (!$6e57a09a8cc86920$var$committeeStatus) return;
    $6e57a09a8cc86920$var$committeeStatus.textContent = text;
    $6e57a09a8cc86920$var$committeeStatus.classList.toggle("is-error", isError);
    clearTimeout($6e57a09a8cc86920$var$committeeStatusTimer);
    if (!isError) $6e57a09a8cc86920$var$committeeStatusTimer = setTimeout(()=>{
        $6e57a09a8cc86920$var$committeeStatus.textContent = "";
    }, 2500);
}
function $6e57a09a8cc86920$var$formatDay(iso) {
    return new Date(iso).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "Europe/Berlin"
    });
}
function $6e57a09a8cc86920$var$isInactive(g) {
    if (g.next) return false;
    return !g.last || Date.now() - new Date(g.last).getTime() > $6e57a09a8cc86920$var$INACTIVE_AFTER_MS;
}
function $6e57a09a8cc86920$var$groupOf(g) {
    var _MATCH_ORDER_find;
    return ((_MATCH_ORDER_find = $6e57a09a8cc86920$var$MATCH_ORDER.find(([, re])=>re.test(g.gremium))) === null || _MATCH_ORDER_find === void 0 ? void 0 : _MATCH_ORDER_find[0]) || "fach";
}
// Abo, das dieses Gremium abdeckt: eigenes für die Kommune oder ein altes
// Abo ohne Kommune („in allen Kommunen“).
function $6e57a09a8cc86920$var$subFor(g) {
    return $6e57a09a8cc86920$var$committees.subs.find((s)=>s.gremium_key === g.key);
}
function $6e57a09a8cc86920$var$anyKommuneSubFor(g) {
    return $6e57a09a8cc86920$var$committees.subs.find((s)=>!s.kommune && s.gremium_key === g.any_key);
}
async function $6e57a09a8cc86920$var$toggleGremium(g, checked) {
    const kommune = $6e57a09a8cc86920$var$committees.kommune;
    const sub = $6e57a09a8cc86920$var$subFor(g);
    const result = checked ? await $6e57a09a8cc86920$var$apiRequest("/committee-subscriptions", "POST", {
        gremium: g.gremium,
        kommune: kommune
    }) : sub ? await $6e57a09a8cc86920$var$apiRequest(`/committee-subscriptions/${sub.id}`, "DELETE") : $6e57a09a8cc86920$var$committees.subs;
    if (!result) {
        $6e57a09a8cc86920$var$showCommitteeStatus("Speichern hat nicht geklappt.", true);
        $6e57a09a8cc86920$var$renderGremienPicker();
        return;
    }
    $6e57a09a8cc86920$var$committees.subs = result;
    $6e57a09a8cc86920$var$showCommitteeStatus(checked ? `${g.gremium} (${kommune}) abonniert.` : `${g.gremium} (${kommune}) abbestellt.`);
    $6e57a09a8cc86920$var$renderCommittees({
        focusKey: g.key
    });
}
async function $6e57a09a8cc86920$var$toggleKommune(kommune, checked) {
    const sub = $6e57a09a8cc86920$var$committees.kommuneSubs.find((s)=>s.kommune === kommune);
    const result = checked ? await $6e57a09a8cc86920$var$apiRequest("/kommune-subscriptions", "POST", {
        kommune: kommune
    }) : sub ? await $6e57a09a8cc86920$var$apiRequest(`/kommune-subscriptions/${sub.id}`, "DELETE") : $6e57a09a8cc86920$var$committees.kommuneSubs;
    if (!result) {
        $6e57a09a8cc86920$var$showCommitteeStatus("Speichern hat nicht geklappt.", true);
        $6e57a09a8cc86920$var$renderGremienPicker();
        return;
    }
    $6e57a09a8cc86920$var$committees.kommuneSubs = result;
    $6e57a09a8cc86920$var$showCommitteeStatus(checked ? `Alle Sitzungen in ${kommune} abonniert.` : `Alle Sitzungen in ${kommune} abbestellt.`);
    $6e57a09a8cc86920$var$renderCommittees();
}
function $6e57a09a8cc86920$var$renderGremienItem(g) {
    const sub = $6e57a09a8cc86920$var$subFor(g);
    const anySub = $6e57a09a8cc86920$var$anyKommuneSubFor(g);
    const label = document.createElement("label");
    label.className = "gremien-item";
    const cb = document.createElement("input");
    cb.type = "checkbox";
    cb.dataset.key = g.key;
    cb.checked = !!(sub || anySub);
    // Ein Abo „in allen Kommunen“ lässt sich nur oben in der Übersicht abbestellen.
    cb.disabled = !sub && !!anySub;
    cb.addEventListener("change", ()=>{
        cb.disabled = true;
        $6e57a09a8cc86920$var$toggleGremium(g, cb.checked);
    });
    const text = document.createElement("span");
    text.className = "gremien-item-text";
    const name = document.createElement("span");
    name.className = "gremien-item-name";
    name.textContent = g.gremium;
    const meta = document.createElement("small");
    meta.className = "gremien-item-meta";
    meta.textContent = [
        g.next ? `n\xe4chste Sitzung ${$6e57a09a8cc86920$var$formatDay(g.next)}` : g.last ? `zuletzt ${$6e57a09a8cc86920$var$formatDay(g.last)}` : "",
        !sub && anySub ? "abonniert f\xfcr alle Kommunen" : ""
    ].filter(Boolean).join(" \xb7 ");
    text.append(name, meta);
    label.append(cb, text);
    return label;
}
function $6e57a09a8cc86920$var$renderGremienPicker({ focusKey: focusKey } = {}) {
    var _committees_overview, _gremienList_querySelector;
    const data = (_committees_overview = $6e57a09a8cc86920$var$committees.overview) === null || _committees_overview === void 0 ? void 0 : _committees_overview.kommunen.find((k)=>k.kommune === $6e57a09a8cc86920$var$committees.kommune);
    $6e57a09a8cc86920$var$gremienPanel.hidden = !data;
    if (!data) return;
    $6e57a09a8cc86920$var$kommuneAllName.textContent = data.kommune;
    $6e57a09a8cc86920$var$kommuneAllToggle.checked = $6e57a09a8cc86920$var$committees.kommuneSubs.some((s)=>s.kommune === data.kommune);
    $6e57a09a8cc86920$var$kommuneAllToggle.disabled = false;
    $6e57a09a8cc86920$var$gremienFilter.hidden = data.gremien.length < $6e57a09a8cc86920$var$FILTER_FROM;
    if ($6e57a09a8cc86920$var$gremienFilter.hidden) $6e57a09a8cc86920$var$committees.query = "";
    $6e57a09a8cc86920$var$gremienFilter.value = $6e57a09a8cc86920$var$committees.query;
    const needle = $6e57a09a8cc86920$var$committees.query.trim().toLocaleLowerCase("de");
    const matching = data.gremien.filter((g)=>!needle || g.gremium.toLocaleLowerCase("de").includes(needle));
    // Abonnierte Gremien bleiben sichtbar, auch wenn sie ruhen.
    const hidden = matching.filter((g)=>$6e57a09a8cc86920$var$isInactive(g) && !$6e57a09a8cc86920$var$subFor(g) && !$6e57a09a8cc86920$var$anyKommuneSubFor(g));
    const visible = $6e57a09a8cc86920$var$committees.showInactive ? matching : matching.filter((g)=>!hidden.includes(g));
    const groups = new Map(Object.keys($6e57a09a8cc86920$var$GROUPS).map((id)=>[
            id,
            []
        ]));
    visible.forEach((g)=>groups.get($6e57a09a8cc86920$var$groupOf(g)).push(g));
    const nodes = [];
    for (const [id, items] of groups){
        if (!items.length) continue;
        const section = document.createElement("div");
        section.className = "gremien-group";
        const h = document.createElement("h3");
        h.className = "gremien-group-title";
        h.textContent = $6e57a09a8cc86920$var$GROUPS[id];
        section.appendChild(h);
        items.forEach((g)=>section.appendChild($6e57a09a8cc86920$var$renderGremienItem(g)));
        nodes.push(section);
    }
    if (!nodes.length) {
        const p = document.createElement("p");
        p.className = "gremien-empty";
        p.textContent = needle ? `Kein Gremium in ${data.kommune} passt zu \u{201E}${$6e57a09a8cc86920$var$committees.query.trim()}\u{201C}.` : "Hier sind nur ruhende Gremien eingetragen.";
        nodes.push(p);
    }
    $6e57a09a8cc86920$var$gremienList.replaceChildren(...nodes);
    $6e57a09a8cc86920$var$gremienList.classList.toggle("is-covered", $6e57a09a8cc86920$var$kommuneAllToggle.checked);
    $6e57a09a8cc86920$var$inactiveToggle.hidden = hidden.length === 0;
    $6e57a09a8cc86920$var$inactiveToggle.textContent = $6e57a09a8cc86920$var$committees.showInactive ? "Ruhende Gremien ausblenden" : hidden.length === 1 ? "1 ruhendes Gremium anzeigen (keine Sitzung seit zwei Jahren)" : `${hidden.length} ruhende Gremien anzeigen (keine Sitzung seit zwei Jahren)`;
    if (focusKey) (_gremienList_querySelector = $6e57a09a8cc86920$var$gremienList.querySelector(`input[data-key="${CSS.escape(focusKey)}"]`)) === null || _gremienList_querySelector === void 0 ? void 0 : _gremienList_querySelector.focus();
}
function $6e57a09a8cc86920$var$makeChip(text, accessibleName, onRemove) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "gremien-chip";
    btn.textContent = `${text} \xd7`;
    btn.setAttribute("aria-label", accessibleName);
    btn.addEventListener("click", async ()=>{
        btn.disabled = true;
        await onRemove();
    });
    return btn;
}
// Übersicht oben: was abonniert ist, nach Kommune gebündelt.
function $6e57a09a8cc86920$var$renderCommitteeOverviewList() {
    const byKommune = new Map();
    const group = (kommune)=>{
        if (!byKommune.has(kommune)) byKommune.set(kommune, {
            all: null,
            gremien: []
        });
        return byKommune.get(kommune);
    };
    $6e57a09a8cc86920$var$committees.kommuneSubs.forEach((s)=>group(s.kommune).all = s);
    $6e57a09a8cc86920$var$committees.subs.forEach((s)=>group(s.kommune || "").gremien.push(s));
    if (byKommune.size === 0) {
        $6e57a09a8cc86920$var$committeeSubsList.replaceChildren($6e57a09a8cc86920$var$makeEmptyItem("Noch keine Gremien abonniert."));
        return;
    }
    const kommunen = [
        ...byKommune.keys()
    ].sort((a, b)=>!a ? 1 : !b ? -1 : a.localeCompare(b, "de"));
    $6e57a09a8cc86920$var$committeeSubsList.replaceChildren(...kommunen.map((kommune)=>{
        const { all: all, gremien: gremien } = byKommune.get(kommune);
        const li = document.createElement("li");
        li.className = "word-item gremien-abo";
        const head = kommune ? document.createElement("button") : document.createElement("span");
        head.className = "word-label gremien-abo-kommune";
        head.textContent = kommune || "In allen Kommunen";
        if (kommune) {
            head.type = "button";
            head.title = `Gremien in ${kommune} bearbeiten`;
            head.addEventListener("click", ()=>$6e57a09a8cc86920$var$selectKommune(kommune, true));
        }
        const chips = document.createElement("div");
        chips.className = "gremien-chips";
        if (all) chips.appendChild($6e57a09a8cc86920$var$makeChip("Alle Sitzungen", `Alle Sitzungen in ${kommune} abbestellen`, ()=>$6e57a09a8cc86920$var$toggleKommune(kommune, false)));
        gremien.sort((a, b)=>a.gremium.localeCompare(b.gremium, "de")).forEach((s)=>{
            chips.appendChild($6e57a09a8cc86920$var$makeChip(s.gremium, `${s.gremium} ${kommune ? "in " + kommune : "in allen Kommunen"} abbestellen`, async ()=>{
                const subs = await $6e57a09a8cc86920$var$apiRequest(`/committee-subscriptions/${s.id}`, "DELETE");
                if (subs) $6e57a09a8cc86920$var$committees.subs = subs;
                $6e57a09a8cc86920$var$renderCommittees();
            }));
        });
        li.append(head, chips);
        return li;
    }));
}
function $6e57a09a8cc86920$var$renderCommittees(options) {
    $6e57a09a8cc86920$var$renderCommitteeOverviewList();
    $6e57a09a8cc86920$var$renderGremienPicker(options);
}
function $6e57a09a8cc86920$var$selectKommune(kommune, focus = false) {
    $6e57a09a8cc86920$var$committees.kommune = kommune;
    $6e57a09a8cc86920$var$committees.query = "";
    $6e57a09a8cc86920$var$committees.showInactive = false;
    $6e57a09a8cc86920$var$kommuneSelect.value = kommune;
    $6e57a09a8cc86920$var$renderGremienPicker();
    if (focus) $6e57a09a8cc86920$var$kommuneSelect.focus();
}
$6e57a09a8cc86920$var$kommuneSelect.addEventListener("change", ()=>$6e57a09a8cc86920$var$selectKommune($6e57a09a8cc86920$var$kommuneSelect.value));
$6e57a09a8cc86920$var$kommuneAllToggle.addEventListener("change", ()=>{
    $6e57a09a8cc86920$var$kommuneAllToggle.disabled = true;
    $6e57a09a8cc86920$var$toggleKommune($6e57a09a8cc86920$var$committees.kommune, $6e57a09a8cc86920$var$kommuneAllToggle.checked);
});
$6e57a09a8cc86920$var$gremienFilter.addEventListener("input", ()=>{
    $6e57a09a8cc86920$var$committees.query = $6e57a09a8cc86920$var$gremienFilter.value;
    $6e57a09a8cc86920$var$renderGremienPicker();
});
$6e57a09a8cc86920$var$inactiveToggle.addEventListener("click", ()=>{
    $6e57a09a8cc86920$var$committees.showInactive = !$6e57a09a8cc86920$var$committees.showInactive;
    $6e57a09a8cc86920$var$renderGremienPicker();
});
async function $6e57a09a8cc86920$var$updateUI() {
    const me = await fetch(`${$6e57a09a8cc86920$var$API_BASE}/auth/me`, {
        credentials: "same-origin"
    }).then((res)=>res.ok ? res.json() : null).catch(()=>null);
    // Anmeldung und die Erklärung "Wofür brauche ich ein Konto?" sind nur für
    // Abgemeldete relevant; die Einstellungen nur für Angemeldete.
    const whySection = document.getElementById("konto-why");
    if (whySection) whySection.hidden = !!me;
    if ($6e57a09a8cc86920$var$loginLayout) $6e57a09a8cc86920$var$loginLayout.hidden = !!me;
    $6e57a09a8cc86920$var$renderAccount(me);
    if (me) {
        $6e57a09a8cc86920$var$authSection.hidden = true;
        $6e57a09a8cc86920$var$wordsSection.hidden = false;
        const data = await $6e57a09a8cc86920$var$apiRequest("/user-data");
        if (data) {
            $6e57a09a8cc86920$var$renderWords(data.words);
            $6e57a09a8cc86920$var$llmSummaryToggle.checked = data.llmSummary;
            $6e57a09a8cc86920$var$weeklyDigestToggle.checked = data.weeklyDigest;
            $6e57a09a8cc86920$var$renderSavedSearches(data.savedSearches || []);
            $6e57a09a8cc86920$var$committees.subs = data.committeeSubscriptions || [];
            $6e57a09a8cc86920$var$committees.kommuneSubs = data.kommuneSubscriptions || [];
            $6e57a09a8cc86920$var$renderCommitteeOverviewList();
            $6e57a09a8cc86920$var$topics.names = data.themengruppen || [];
            $6e57a09a8cc86920$var$topics.subs = data.topicSubscriptions || [];
            $6e57a09a8cc86920$var$renderTopics();
        }
        await Promise.all([
            $6e57a09a8cc86920$var$loadCommitteeOverview(),
            $6e57a09a8cc86920$var$loadTopicKommunen()
        ]);
    } else {
        $6e57a09a8cc86920$var$authSection.hidden = false;
        $6e57a09a8cc86920$var$wordsSection.hidden = true;
    }
}
function $6e57a09a8cc86920$var$renderAccount(me) {
    if ($6e57a09a8cc86920$var$lede) $6e57a09a8cc86920$var$lede.textContent = me ? "Hier legst du fest, wor\xfcber wir dich per E-Mail informieren." : $6e57a09a8cc86920$var$LEDE_LOGGED_OUT;
    if (!$6e57a09a8cc86920$var$accountLine) return;
    $6e57a09a8cc86920$var$accountLine.replaceChildren();
    if (me && me.email) {
        const strong = document.createElement("strong");
        strong.textContent = me.email;
        $6e57a09a8cc86920$var$accountLine.append("Angemeldet als ", strong);
    }
}
let $6e57a09a8cc86920$var$settingsStatusTimer = null;
function $6e57a09a8cc86920$var$showSettingsStatus(text, isError = false) {
    if (!$6e57a09a8cc86920$var$settingsStatus) return;
    $6e57a09a8cc86920$var$settingsStatus.textContent = text;
    $6e57a09a8cc86920$var$settingsStatus.classList.toggle("is-error", isError);
    clearTimeout($6e57a09a8cc86920$var$settingsStatusTimer);
    if (!isError) $6e57a09a8cc86920$var$settingsStatusTimer = setTimeout(()=>{
        $6e57a09a8cc86920$var$settingsStatus.textContent = "";
    }, 2500);
}
async function $6e57a09a8cc86920$var$saveSetting(body) {
    try {
        const ok = await $6e57a09a8cc86920$var$apiRequest("/settings", "POST", body);
        if (ok) $6e57a09a8cc86920$var$showSettingsStatus("Gespeichert.");
        else $6e57a09a8cc86920$var$showSettingsStatus("Speichern hat nicht geklappt.", true);
    } catch  {
        $6e57a09a8cc86920$var$showSettingsStatus("Speichern hat nicht geklappt.", true);
    }
}
$6e57a09a8cc86920$var$llmSummaryToggle.addEventListener("change", (e)=>{
    $6e57a09a8cc86920$var$saveSetting({
        llmSummary: e.target.checked
    });
});
$6e57a09a8cc86920$var$weeklyDigestToggle.addEventListener("change", (e)=>{
    $6e57a09a8cc86920$var$saveSetting({
        weeklyDigest: e.target.checked
    });
});
function $6e57a09a8cc86920$var$setLoginMessage(text, kind) {
    $6e57a09a8cc86920$var$loginMessage.textContent = text;
    $6e57a09a8cc86920$var$loginMessage.className = kind ? `is-${kind}` : "";
}
$6e57a09a8cc86920$var$loginForm.addEventListener("submit", async (e)=>{
    e.preventDefault();
    const email = document.getElementById("email").value.trim();
    if (!email) return;
    if ($6e57a09a8cc86920$var$loginSubmit) $6e57a09a8cc86920$var$loginSubmit.disabled = true;
    $6e57a09a8cc86920$var$setLoginMessage("Link wird verschickt \u2026", "pending");
    try {
        const res = await fetch(`${$6e57a09a8cc86920$var$API_BASE}/auth/magic-link`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify({
                email: email
            })
        });
        if (res.ok) $6e57a09a8cc86920$var$setLoginMessage(`Wir haben dir einen Anmeldelink an ${email} geschickt. Bitte pr\xfcfe dein Postfach.`, "ok");
        else if (res.status === 429) $6e57a09a8cc86920$var$setLoginMessage("Zu viele Versuche. Bitte warte ein paar Minuten und versuche es dann noch einmal.", "error");
        else if (res.status === 400) $6e57a09a8cc86920$var$setLoginMessage("Bitte gib eine g\xfcltige E-Mail-Adresse ein.", "error");
        else $6e57a09a8cc86920$var$setLoginMessage("Der Link konnte gerade nicht verschickt werden. Bitte versuche es sp\xe4ter noch einmal.", "error");
    } catch  {
        $6e57a09a8cc86920$var$setLoginMessage("Keine Verbindung zum Server. Bitte versuche es sp\xe4ter noch einmal.", "error");
    } finally{
        if ($6e57a09a8cc86920$var$loginSubmit) $6e57a09a8cc86920$var$loginSubmit.disabled = false;
    }
});
$6e57a09a8cc86920$var$addWordForm.addEventListener("submit", async (e)=>{
    e.preventDefault();
    const input = document.getElementById("new-word");
    const word = input.value.trim();
    if (word) {
        const words = await $6e57a09a8cc86920$var$apiRequest("/words", "POST", {
            word: word
        });
        input.value = "";
        if (words) $6e57a09a8cc86920$var$renderWords(words);
    }
});
window.removeWord = async (word)=>{
    const words = await $6e57a09a8cc86920$var$apiRequest("/words", "DELETE", {
        word: word
    });
    if (words) $6e57a09a8cc86920$var$renderWords(words);
};
window.deleteSavedSearch = async (id)=>{
    const searches = await $6e57a09a8cc86920$var$apiRequest(`/saved-searches/${id}`, "DELETE");
    $6e57a09a8cc86920$var$renderSavedSearches(searches || []);
};
function $6e57a09a8cc86920$var$makeRemoveButton(accessibleName, onRemove) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "remove-btn";
    btn.textContent = "Entfernen";
    btn.setAttribute("aria-label", accessibleName);
    btn.addEventListener("click", onRemove);
    return btn;
}
// Eine Listenzeile: Bezeichnung (Text oder Link), optional eine Zusatzzeile,
// rechts der Entfernen-Knopf.
function $6e57a09a8cc86920$var$makeWordItem(labelText, onRemove, { href: href, meta: meta } = {}) {
    const li = document.createElement("li");
    li.className = "word-item";
    const main = document.createElement("span");
    main.className = "word-main";
    const label = document.createElement(href ? "a" : "span");
    label.className = "word-label";
    if (href) label.href = href;
    label.textContent = labelText;
    main.appendChild(label);
    if (meta) {
        const small = document.createElement("span");
        small.className = "word-meta";
        small.textContent = meta;
        main.appendChild(small);
    }
    li.appendChild(main);
    li.appendChild($6e57a09a8cc86920$var$makeRemoveButton(`\u{201E}${labelText}\u{201C} entfernen`, onRemove));
    return li;
}
function $6e57a09a8cc86920$var$makeEmptyItem(text) {
    const li = document.createElement("li");
    li.className = "word-item word-empty";
    li.textContent = text;
    return li;
}
function $6e57a09a8cc86920$var$renderWords(words) {
    while($6e57a09a8cc86920$var$wordsList.firstChild)$6e57a09a8cc86920$var$wordsList.removeChild($6e57a09a8cc86920$var$wordsList.firstChild);
    if (!words.length) {
        $6e57a09a8cc86920$var$wordsList.appendChild($6e57a09a8cc86920$var$makeEmptyItem("Noch keine Begriffe."));
        return;
    }
    words.forEach((word)=>{
        $6e57a09a8cc86920$var$wordsList.appendChild($6e57a09a8cc86920$var$makeWordItem(word, ()=>window.removeWord(word)));
    });
}
// Kurzbeschreibung einer gespeicherten Suche aus ihrem Query-String.
function $6e57a09a8cc86920$var$describeQuery(query) {
    try {
        const params = new URLSearchParams(query || "");
        const q = (params.get("q") || "").trim();
        let filters = 0;
        for (const key of new Set(params.keys()))if (key !== "q" && key !== "page") filters += 1;
        const parts = [];
        if (q) parts.push(`Suchbegriff \u{201E}${q}\u{201C}`);
        if (filters) parts.push(filters === 1 ? "1 Filter" : `${filters} Filter`);
        return parts.join(" \xb7 ");
    } catch  {
        return "";
    }
}
function $6e57a09a8cc86920$var$renderSavedSearches(searches) {
    while($6e57a09a8cc86920$var$savedSearchesList.firstChild)$6e57a09a8cc86920$var$savedSearchesList.removeChild($6e57a09a8cc86920$var$savedSearchesList.firstChild);
    if (!searches.length) {
        $6e57a09a8cc86920$var$savedSearchesList.appendChild($6e57a09a8cc86920$var$makeEmptyItem("Noch keine gespeicherten Suchen."));
        return;
    }
    searches.forEach((s)=>{
        // s.query ist der gespeicherte window.location.search (beginnt mit "?").
        $6e57a09a8cc86920$var$savedSearchesList.appendChild($6e57a09a8cc86920$var$makeWordItem(s.name, ()=>window.deleteSavedSearch(s.id), {
            href: "/suche" + s.query,
            meta: $6e57a09a8cc86920$var$describeQuery(s.query)
        }));
    });
}
$6e57a09a8cc86920$var$logoutBtn.addEventListener("click", async ()=>{
    var _document_getElementById;
    await fetch(`${$6e57a09a8cc86920$var$API_BASE}/auth/logout`, {
        method: "POST",
        credentials: "same-origin"
    });
    await $6e57a09a8cc86920$var$updateUI();
    (_document_getElementById = document.getElementById("email")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
});
$6e57a09a8cc86920$var$updateUI();


//# sourceMappingURL=konto.0ed17ca8.js.map
